export enum CheckoutErrorCode {
  SoldOut = "SOLD_OUT",
  MaxTickets = "MAX_TICKETS",
  SessionUnavailable = "SESSION_UNAVAILABLE",
  EventCancelled = "EVENT_CANCELLED",
  PricingOptionUnavailable = "PRICING_OPTION_UNAVAILABLE",
  DeliveryRequired = "DELIVERY_REQUIRED",
  DeliveryUnavailable = "DELIVERY_UNAVAILABLE",
  InvoiceNotFound = "INVOICE_NOT_FOUND",
  InvoiceStale = "INVOICE_STALE",
  InvoiceNotPayable = "INVOICE_NOT_PAYABLE",
  InvoiceAlreadyOrdered = "INVOICE_ALREADY_ORDERED",
  NotEligible = "NOT_ELIGIBLE",
  BusinessesCoveredElsewhere = "BUSINESSES_COVERED_ELSEWHERE",
  RenewalNotOpen = "RENEWAL_NOT_OPEN",
  ApprovalWindowTooShort = "APPROVAL_WINDOW_TOO_SHORT",
  PromoInvalid = "PROMO_INVALID",
  PromoExpired = "PROMO_EXPIRED",
  PromoDepleted = "PROMO_DEPLETED",
  PromoNotApplicable = "PROMO_NOT_APPLICABLE",
  PaymentMethodDisabled = "PAYMENT_METHOD_DISABLED",
  PaymentCustomerFailed = "PAYMENT_CUSTOMER_FAILED",
  PaymentIntentFailed = "PAYMENT_INTENT_FAILED",
  ChargeDeclined = "CHARGE_DECLINED",
  ChargeAuthRequired = "CHARGE_AUTH_REQUIRED",
  ChargeFailed = "CHARGE_FAILED",
  PaymentConfig = "PAYMENT_CONFIG",
  PaymentAccountMissing = "PAYMENT_ACCOUNT_MISSING",
  BookerNotFound = "BOOKER_NOT_FOUND",
  StorefrontNotFound = "STOREFRONT_NOT_FOUND",
  TestUserLiveStorefront = "TEST_USER_LIVE_STOREFRONT",
  OrderPersistence = "ORDER_PERSISTENCE",
  Unknown = "UNKNOWN",
  StripeUnavailable = "STRIPE_UNAVAILABLE",
  CardInvalid = "CARD_INVALID",
  Network = "NETWORK",
}

export const CHECKOUT_ERROR_CODES = Object.values(
  CheckoutErrorCode,
) as CheckoutErrorCode[];

export const CLIENT_CHECKOUT_ERROR_CODES = [
  CheckoutErrorCode.StripeUnavailable,
  CheckoutErrorCode.CardInvalid,
  CheckoutErrorCode.Network,
] as const;

export const BACKEND_CHECKOUT_ERROR_CODES = CHECKOUT_ERROR_CODES.filter(
  code =>
    !(CLIENT_CHECKOUT_ERROR_CODES as readonly CheckoutErrorCode[]).includes(
      code,
    ),
);

const CHECKOUT_ERROR_CODE_SET = new Set<string>(CHECKOUT_ERROR_CODES);

export function isCheckoutErrorCode(value: unknown): value is CheckoutErrorCode {
  return typeof value === "string" && CHECKOUT_ERROR_CODE_SET.has(value);
}
